/**
 * <offer-modal> (snippets/offer-modal.liquid).
 *
 * A top-layer <dialog> explaining how to claim the payment offer. Built on
 * window.ThemeOverlay (assets/overlay-motion.js) rather than on its own
 * plumbing - that module already owns open/close motion, the scroll lock
 * (which is stack-aware, because this can open over the cart drawer) and
 * focus restore. A fifth private implementation of all three is how they
 * drift apart.
 *
 * The YouTube src is held in data-offer-video and only written to the iframe
 * on first open. This note is a block on every product page, so loading the
 * embed eagerly would cost several hundred kilobytes and a set of
 * third-party cookies on every product view for something most visitors
 * never open.
 */
(function () {
  if (customElements.get('offer-modal')) return;

  class OfferModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-offer-dialog]');
      this.opener = this.querySelector('[data-offer-open]');
      if (!this.dialog || !this.opener) return;

      this.onOpen = this.onOpen.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onClick = this.onClick.bind(this);

      this.opener.addEventListener('click', this.onOpen);
      this.dialog.addEventListener('close', this.onDialogClose);
      this.dialog.addEventListener('click', this.onClick);

      var closer = this.querySelector('[data-offer-close]');
      if (closer) closer.addEventListener('click', this.onClose);
    }

    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    loadVideo() {
      var frame = this.querySelector('[data-offer-video]');
      if (!frame || frame.src) return;
      frame.src = frame.dataset.offerVideo;
    }

    onOpen() {
      this.loadVideo();

      if (window.ThemeOverlay) {
        window.ThemeOverlay.cancelClose(this.dialog);
        window.ThemeOverlay.openDialog(this.dialog);
        window.ThemeOverlay.lockScroll(this);
      } else {
        this.dialog.showModal();
      }
    }

    onClose() {
      if (window.ThemeOverlay) {
        window.ThemeOverlay.closeDialog(this.dialog);
      } else {
        this.dialog.close();
      }
    }

    /* Fires for Escape as well as for our own close, which is why the
       unlock lives here rather than in onClose - a dialog dismissed with the
       keyboard would otherwise leave the page scroll-locked. */
    onDialogClose() {
      if (!window.ThemeOverlay) return;
      window.ThemeOverlay.unlockScroll(this);
      window.ThemeOverlay.cancelClose(this.dialog);
      window.ThemeOverlay.restoreFocus(this.opener);
    }

    /* A click landing on the <dialog> itself is the backdrop: the panel
       inside it covers every pixel the visitor could otherwise hit. */
    onClick(event) {
      if (event.target === this.dialog) this.onClose();
    }
  }

  customElements.define('offer-modal', OfferModal);
})();
